import cn from 'classnames'
import { Box, Divider } from 'components/Material/index'

type SidebarBoxProps = {
  children: React.ReactNode
  className?: string
  divider?: boolean
}

export const SidebarBox = ({ children, className, divider = true }: SidebarBoxProps) => {
  return (
    <Box className="w-full">
      <Box className={cn('w-full flex flex-col items-center', { 'pb-5': divider })}>
        <Box className={cn('w-full', {}, className)}>{children}</Box>
      </Box>
      {divider && (
        <Box>
          <Divider
            variant="fullWidth"
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              zIndex: 200
            }}
          />
        </Box>
      )}
    </Box>
  )
}
